module.exports = {"sld:ColorMapEntry":[{"quantity":-999,"color":"#FFFFFF","label":"NO DATA"},{"quantity":0,"color":"#D7D7D7","label":"0"},{"quantity":0,"color":"#198CDB","label":"<=0.35"},{"quantity":0.001,"color":"#91E3AD","label":"0.35 - 1.01"},{"quantity":0.03,"color":"#DEFFB0","label":"1.01 - 1.8"},{"quantity":0.06,"color":"#FFE68C","label":"1.8 - 3"},{"quantity":0.1,"color":"#FF9982","label":"3 - 5.39"},{"quantity":12,"color":"#FF4D30","label":"5.39 - 9.06"}]}


//////////////////
// WEBPACK FOOTER
// ./static/bunSld_cropRisks/county_maize_wheat_rice_mme_1981_2016_lcr_80_rice.json
// module id = bgdS
// module chunks = 171